// Central brand / contact constants for UNIRAD DIAGNOSTICS
export const SITE = {
  name: "UNIRAD DIAGNOSTICS",
  tagline: "Accurate Diagnostics. Trusted Care.",
  website: "www.unirad.in",
  email: "admin@unirad.in",
  address: {
    line1: "Upper Ground Floor, RS Plaza",
    line2: "Adarsh Nagar",
    city: "Lucknow, Uttar Pradesh - 226022",
    full: "Upper Ground Floor, RS Plaza, Adarsh Nagar, Lucknow, Uttar Pradesh - 226022",
  },
  phones: [
    { label: "WhatsApp", number: "9044139292" },
    { label: "Reception", number: "9044159292" },
    { label: "Landline", number: "0522-4269518" },
  ],
  whatsapp: "9044139292",
  callPrimary: "9044159292",
  hours: [
    { day: "Monday – Saturday", time: "7:00 AM – 9:00 PM" },
    { day: "Sunday", time: "8:00 AM – 2:00 PM" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=RS%20Plaza%2C%20Adarsh%20Nagar%2C%20Lucknow%2C%20Uttar%20Pradesh%20226022&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=RS+Plaza+Adarsh+Nagar+Lucknow+226022",
};

export const whatsappHref = (text) =>
  `https://wa.me/91${SITE.whatsapp}?text=${encodeURIComponent(
    text || "Hi UNIRAD DIAGNOSTICS, I'd like to enquire about a diagnostic test."
  )}`;

export const callHref = `tel:+91${SITE.callPrimary}`;

export const IMAGES = {
  heroBg: "https://images.pexels.com/photos/13176356/pexels-photo-13176356.jpeg",
  aboutCare: "https://images.unsplash.com/photo-1576671081741-c538eafccfff?auto=format&fit=crop&w=1200&q=80",
  ultrasound: "https://images.pexels.com/photos/7088828/pexels-photo-7088828.jpeg",
  xray: "https://images.pexels.com/photos/7617612/pexels-photo-7617612.jpeg",
  pathology: "https://images.unsplash.com/photo-1639772823849-6efbd173043c?auto=format&fit=crop&w=1200&q=80",
  radiology: "https://images.pexels.com/photos/15277956/pexels-photo-15277956.jpeg",
  interventions: "https://images.pexels.com/photos/19819125/pexels-photo-19819125.jpeg",
  team: "https://images.unsplash.com/photo-1778230123972-07eafe417fc4?auto=format&fit=crop&w=1200&q=80",
  reception: "https://images.pexels.com/photos/33812025/pexels-photo-33812025.jpeg",
  patient1: "https://images.unsplash.com/photo-1612636320854-776180f479d8?auto=format&fit=crop&w=400&q=80",
  patient2: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?auto=format&fit=crop&w=400&q=80",
  patient3: "https://images.unsplash.com/photo-1484863137850-59afcfe05386?auto=format&fit=crop&w=400&q=80",
};
